// V2 API client + auth helpers
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (!BACKEND_URL) throw new Error('REACT_APP_BACKEND_URL is required');
export const V2_API = `${BACKEND_URL}/api/v2`;
export const API = `${BACKEND_URL}/api`;

export function authHeaders() {
  const token = localStorage.getItem('taillink_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function apiGet(path) {
  const r = await fetch(path, { headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', ...authHeaders() }, cache: 'no-store' });
  if (!r.ok) throw new Error(`GET ${path} → ${r.status}`);
  return r.json();
}

export async function apiPost(path, body) {
  const r = await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(body || {}),
  });
  if (!r.ok) throw new Error(`POST ${path} → ${r.status}`);
  return r.json();
}

export async function apiPut(path, body) {
  const r = await fetch(path, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(body || {}),
  });
  if (!r.ok) throw new Error(`PUT ${path} → ${r.status}`);
  return r.json();
}

export async function apiDelete(path, body) {
  const r = await fetch(path, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!r.ok) throw new Error(`DELETE ${path} → ${r.status}`);
  return r.json();
}

export function isLoggedIn() {
  return Boolean(localStorage.getItem('taillink_token'));
}

export async function clearAuthSession({ reload = false } = {}) {
  localStorage.removeItem('taillink_token');
  localStorage.removeItem('taillink_user');
  localStorage.removeItem('tl_swr_cache_v1');
  localStorage.removeItem('tl_post_login_redirect');
  document.cookie = 'taillink_token=; Max-Age=0; path=/; SameSite=Lax';
  document.cookie = 'access_token=; Max-Age=0; path=/; SameSite=Lax';
  document.cookie = 'refresh_token=; Max-Age=0; path=/; SameSite=Lax';
  try { await fetch(`${API}/auth/logout`, { method: 'POST', credentials: 'include', cache: 'no-store' }); } catch {}
  window.dispatchEvent(new Event('tl-auth-changed'));
  if (reload) window.location.reload();
}
